// src/components/accordion/accordion.styles.ts
import { tv } from "tailwind-variants";
var accordionStyles = tv({
  slots: {
    container: [
      "rounded-lg border border-neutral-20",
      "bg-neutral-0 transition-colors duration-300 ease-in-out",
      "hover:bg-default-100"
    ],
    contentWrapper: "grid transition-all duration-300 ease-in-out grid-rows-[0fr]",
    contentOverflow: "overflow-hidden",
    content: "px-4",
    titleContainer: ["flex w-full text-left", "flex-col", "relative", "p-4"],
    chevron: [
      "h-7 transition-all duration-300 ease-in-out",
      "absolute right-4 top-4 md:top-1/2 md:-translate-y-1/2"
    ],
    title: [
      "text-base font-semibold text-[#232323] leading-6",
      "flex justify-between items-center md:justify-start"
    ],
    titleWithSubtitle: [
      "flex items-baseline w-full",
      "justify-between md:justify-start",
      "pr-8"
    ],
    subtitle: [
      "text-neutral-600 text-sm",
      "md:ml-2",
      "absolute md:static right-12 top-5 md:right-auto"
    ],
    description: [
      "w-64 text-sm text-neutral-600 truncate",
      "mt-1 md:hidden",
      "pr-8"
    ]
  },
  variants: {
    borders: {
      default: {},
      none: {},
      topOnly: {},
      bottomOnly: {
        container: "border-0 border-b rounded-none"
      },
      topAndBottomOnly: {
        container: "border-0 border-b rounded-none border-t"
      }
    },
    borderWidth: { thin: "", default: "" },
    open: {
      true: {
        container: "hover:border-neutral-500",
        contentWrapper: "grid-rows-[1fr]",
        chevron: "rotate-180"
      }
    },
    customOpenStyles: {
      true: {
        container: ["bg-blue-50 pb-4", "hover:border-neutral-500"]
      }
    }
  }
});
export {
  accordionStyles
};
